import { Vehicle } from "./vehicle.model";

export class Route {
    id?: number;
    description?: string;
    domain?: any;
    vehicle?: any;
    driver?: any;
    locationsRoute?: any[];
    recurrency?: any
    initTime?: string;
}